import { render, staticRenderFns } from "./EnergyLabel.vue?vue&type=template&id=2a36e7d5&"
import script from "./EnergyLabel.vue?vue&type=script&lang=ts&"
export * from "./EnergyLabel.vue?vue&type=script&lang=ts&"
import style0 from "./EnergyLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports